


































import {
  defineComponent,
  PropType,
  getCurrentInstance
} from "@vue/composition-api";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import InputFieldBase from "../Base.vue";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  components: {
    InputFieldBase,
    TextField
  },
  name: "InputFieldLabelEditable",
  props: {
    orderable: {
      type: Object as PropType<{ raise: boolean; lower: boolean }>,
      default: undefined
    },
    deletable: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: undefined
    },
    warnMessage: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    labelPlaceholderText: {
      type: String,
      default: ""
    },
    dataIndex: {
      type: Number,
      default: 0
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const instance = getCurrentInstance();
    const onMoveOrder = (event: Event) => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_並び替え`
        });
      }
      emit("moveOrder", event);
    };
    const onDelete = () => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_削除`
        });
      }
      emit("delete");
    };
    return {
      onMoveOrder,
      onDelete
    };
  }
});
